export const formatearBogota = (isoString) => {
  if (!isoString) return '';
  const fecha = new Date(isoString);
  try {
    return new Intl.DateTimeFormat('es-CO', {
      timeZone: 'America/Bogota',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(fecha);
  } catch (e) {
    // Fallback si Intl no soporta la zona (ambiente muy antiguo)
    return fecha.toLocaleString('es-CO');
  }
};


